import React from "react";

export const SpaServiceCard = ({ service, index }) => {
  return (
    <div
      data-testid={`spa-service-${service.slug}`}
      className="group bg-cream p-8 md:p-10 reveal flex flex-col"
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden mb-6">
        <img
          src={service.image}
          alt={service.name}
          className="w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-110"
        />
      </div>
      <div className="label-eyebrow mb-3">0{index + 1}</div>
      <h3 className="font-serif text-2xl font-light leading-tight">{service.name}</h3>
      <p className="font-serif italic text-gold-dark mt-2 text-sm">{service.tagline}</p>
      <p className="text-ink/60 text-sm mt-4 leading-relaxed flex-1">{service.summary}</p>
      <ul className="mt-6 flex flex-col gap-1.5">
        {service.benefits.map((benefit) => (
          <li
            key={benefit}
            className="flex items-center gap-2 text-[11px] tracking-wide text-ink/70"
          >
            <span className="w-1 h-1 rounded-full bg-gold flex-shrink-0" />
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  );
};
